import { render, staticRenderFns } from "./2-onboarding.vue?vue&type=template&id=dda3079a&scoped=true&"
import script from "./2-onboarding.vue?vue&type=script&lang=js&"
export * from "./2-onboarding.vue?vue&type=script&lang=js&"
import style0 from "./2-onboarding.vue?vue&type=style&index=0&id=dda3079a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda3079a",
  null
  
)

export default component.exports